<script lang="ts" setup>

</script>

<template>
  <div class="relative">
    <svg class="animate-pulse" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 54 50">
      <path fill="#6DAADD" fill-rule="evenodd" d="m27 0 6.3 19H20.8L27 0ZM10.7 50 27 38.3 43.3 50H10.7Zm32.6 0-6.2-19 16.3-12-10.1 31ZM.7 19.1l16.2 11.8L10.7 50 .7 19.1Z" clip-rule="evenodd" />
    </svg>
  </div>
</template>

<style>

</style>
